import {createFileRoute} from '@tanstack/react-router';
import BookCourtCheckoutView from '../../../marketplace/BookCourtCheckoutView';

export const Route = createFileRoute('/_app/book-court/checkout')({
    component: RouteComponent,
});

function RouteComponent() {
    return <BookCourtCheckoutView />;
}
